import React from 'react';
import ComponentFactory from './component-factory/ComponentFactory';
import RenderHtml from './editor/indexRenderHtml';

export default () => {
  ComponentFactory.getComponents();

  return <RenderHtml />;
};
